"use client";

import HcpAccordion from '@/components-hcp/accordion';
import CustomImage from '@/components/image';
import styles from './_discontinuation.module.scss';

export default function HcpClinicalInformationDiscontinuation() {
  return (
    <div className={styles.discon}>
      <HcpAccordion
        label={<>Review discontinuation details</>}
      >
        <div className={`container ${styles.discon_container}`}>
          <h2 className={styles.discon_heading}>Adverse reactions that led to discontinuation during the double-blind phases<sup>1</sup></h2>
          <div className={styles.discon_data}>
            <div className={styles.discon_trial}>
              <div className={styles.discon_data_heading}>
                <CustomImage
                  src='/images/components/hcp-clinical-information_discontinuation_data-icon1.svg'
                  width={54}
                  height={54}
                  alt='icon of two people'/>
                <span className="text-hcp-eggplant">CAHtalyst<sup>&reg;</sup> Pediatric<sup>1</sup></span>
              </div>
              <ul className={styles.discon_data_list}>
                <li>Abdominal pain</li>
                <li>Myalgia</li>
                <li>Dizziness</li>
              </ul>
            </div>
            <div className={styles.discon_trial}>
              <div className={styles.discon_data_heading}>
                <CustomImage
                  src='/images/components/hcp-clinical-information_discontinuation_data-icon2.svg'
                  width={54}
                  height={54}
                  alt='icon of a person'/>
                <span className="text-hcp-eggplant">CAHtalyst<sup>&reg;</sup> Adult<sup>1</sup></span>
              </div>
              <ul className={styles.discon_data_list}>
                <li>Restlessness</li>
                <li>Apathy</li>
                <li>Dyspepsia</li>
                <li>Nausea</li>
                <li>Vomiting</li>
              </ul>
            </div>
          </div>
        </div>
      </HcpAccordion>
    </div>
  );
}
